import { Box, Modal, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
// import {
//   CloseModalIcon,
//   TrendChartIcon,
// } from "../../../common/components/assets/commonassets/CommonAssets";
import { ModalStyle } from "../../../common/components/ModalStyle";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { useForm } from "react-hook-form";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import useGeneratePdf from "../../../common/components/printModal/GeneratePdfHook";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import {
  TrendChartIcon,
} from "../../../assets/CommonAssets";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";

import InputField from "../../../common/components/FormFields/InputField";
// import {
  // radiologyGeneratePdf,
  // getPathologyTestParameters,
  // getRadiologyTestTemplates,
  // pathologyGeneratePdf,
  // getParameterTrend,
// } from "../../../IPD/services/discharge/dischargeServices";
import ViewTrendModal from "./ViewTrendChart";
// import { generatePdf } from "../Radiology/services/WorkOrderViewServices";
// import useGeneratePdf from "../../../common/components/Custom Hooks/UseGeneratePdf";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function PathologyReportModal(props) {
  const {
    openInvestigationModal,
    setOpenInvestigationModal,
    patientInfo,
    selectedInvestigations,
    setSelectedInvestigation,
    openLIMSHistoryModal,
    setOpenLIMSHistoryModal,
    pathHistoryData,
    radioHistoryData,
    LIMSType,
    getDischargeSummary,
    userRole,
  } = props;
  const { control, watch } = useForm();
  const [values, setValues] = useState(0);
  const [selectedPathTestIndex, setSelectedPathTestIndex] = useState(0);
  const [selectedPathTest, setSelectedPathTest] = useState(null);
  const [selectedRadioTestIndex, setSelectedRadioTestIndex] = useState(0);
  const [selectedRadioReportIndex, setSelectedRadioReportIndex] =
    useState(null);
  const [selectedRadioTest, setSelectedRadioTest] = useState(null);
  const [reportPdf, setReportPdf] = useState("");
  const [isReport, setIsReport] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [selectedTestParameters, setSelectedTestParameters] = useState([]);
  const [selectedTestTemplates, setSelectedTestTemplates] = useState([]);
  const [selectedParameterInd, setSelectedParameterInd] = useState([]);
  const [selectedDateInd, setSelectedDateInd] = useState([]);
  const [templateOrParameter, setTemplateOrParameter] = useState("");
  const [selectedPathReportIndex, setSelectedPathReportIndex] = useState(null);
  const [parameterTrendData, setParameterTrendData] = useState([]);
  const [currentParameterTrendData, setCurrentParameterTrendData] = useState(
    {}
  );
  const [graphData, setGraphData] = useState([]);
  const [openTrendModal, setOpenTrendModal] = React.useState(false);
  // const handleChange = (event, newValue) => {
  // setValues(newValue);
  // };

  // console.log("props.userRole", selelect);

  const getParametersList = (testId) => {
    // getPathologyTestParameters(
    //   patientInfo?.patientInfoId || patientInfo?.patientId,
    //   patientInfo?.lastVisitId ||
    //     patientInfo?.visitId ||
    //     patientInfo?.patientVisitId,
    //   testId
    // ).then((response) => {
    //   let newArray = [];
    //   response.data.result?.forEach((jsonObject) => {
    //     let parsedObject = JSON.parse(jsonObject);
    //     parsedObject.dateChecked = false;
    //     parsedObject.testParameters = parsedObject.testParameters.map(
    //       (parameter) => ({
    //         ...parameter,
    //         parameterChecked: false,
    //       })
    //     );

    //     newArray.push(parsedObject);
    //   });
    //   if (
    //     newArray?.some(
    //       (val) =>
    //         val?.isTemplate === true &&
    //         (val?.isCultureTest === true || val?.isCultureTest === false)
    //     )
    //   ) {
    //     setTemplateOrParameter("template");
    //   } else if (
    //     newArray?.some(
    //       (val) =>
    //         val?.isTemplate === false &&
    //         (val?.isCultureTest === true || val?.isCultureTest === false)
    //     )
    //   ) {
    //     setTemplateOrParameter("parameter");
    //   }
    //   setSelectedTestParameters(newArray);
    // });
  };

  useEffect(() => {
    if (pathHistoryData?.length > 0) {
      setSelectedPathTest(pathHistoryData[0]);
      getParametersList(pathHistoryData[0]?.testId);
      setSelectedPathTestIndex(0);
    }
  }, [pathHistoryData]);

  const getRadiologytemplates = (testId) => {
    console.log("patientInfopatientInfopatientInfo", patientInfo);

    // getRadiologyTestTemplates(
    //   patientInfo?.patientInfoId || patientInfo?.patientId,
    //   patientInfo?.patientVisitId || patientInfo?.visitId,
    //   testId
    // )
    //   .then((response) => {
    //     let newArray = [];
    //     response.data.result?.forEach((jsonObject) => {
    //       newArray.push(JSON.parse(jsonObject));
    //     });
    //     setSelectedTestTemplates(newArray);
    //   })
    //   .catch((err) => err);
  };

  useEffect(() => {
    if (radioHistoryData?.length > 0) {
      setSelectedRadioTest(radioHistoryData?.[0]);
      getRadiologytemplates(radioHistoryData?.[0]?.testId);
      setSelectedRadioTestIndex(0);
    }
  }, [radioHistoryData]);

  // const handlePrintReport = (patientVisitId, orderId, investigationId) => {
  //   console.log("orderId77777");
  //   setIsReport(true);
  //   generateReport(patientVisitId, orderId, 2552, investigationId)
  //     .then((response) => {
  //       console.log("PDF Response", response);
  //       if (response.status === 200) {
  //         setReportPdf(response);
  //       }
  //     })
  //     .catch((response) => {
  //       console.log("response catch", response);
  //     });
  // };

  const handlePrintReport = (
    patientVisitId,
    orderId,
    investigationId,
    type
  ) => {
    // if (type === "pathology") {
    setIsReport(true);
    // pathologyGeneratePdf({
    //   patientVisitId: patientVisitId,
    //   investigationId: [investigationId],
    //   orderId: orderId,
    //   unitId: userRole?.loginUnitId,
    // })
    //   .then((response) => {
    //     if (response.status === 200) {
    //       setReportPdf(response);
    //     }
    //   })
    //   .catch((response) => {
    //     console.log("response catch", response);
    //   });
    // } else if (type === "radiology") {
    //   setIsReport(true);
    //   radiologyGeneratePdf(
    //     patientVisitId,
    //     orderId,
    //     userRole?.employeeId,
    //     investigationId
    //   )
    //     .then((response) => {
    //       if (response.status === 200) {
    //         setReportPdf(response);
    //       }
    //     })
    //     .catch((response) => {
    //       console.log("response catch", response);
    //     });
    // }
  };

  const fileURL = useGeneratePdf(reportPdf);
  // console.log("fileURLfileURL123", fileURL);

  // useEffect(() => {
  //   let parameterDetailsArr = [];
  //   let tempData = [...selectedTestParameters];
  //   for (let po of selectedTestParameters) {
  //     let parameterDetailsObj = {};
  //     let parameters = [];
  //     console.log("popopopo123", po);
  //     if (po.dateChecked === true) {
  //       parameterDetailsObj.investigationDate = po.investigationDate;
  //       for (let pc of po.testParameters) {
  //         let parameterObj = {};
  //         console.log("pcpcpcpc123", pc);
  //         if (pc.parameterChecked === true) {
  //           parameterObj.parameterName = pc.parameterName;
  //           parameterObj.reportValues = pc.finalResult;
  //           parameterObj.normalRange = pc.normalRange;
  //           parameters.push(parameterObj);
  //           console.log("parameters12345", parameters);
  //         }

  //       }
  //       parameterDetailsObj.parameters = parameters;
  //       parameterDetailsArr.push(parameterDetailsObj);
  //     }
  //     console.log("parameterDetails123", parameterDetailsArr);
  //   }
  //   setSelectedTestParameters(tempData);
  // }, [selectedParameterInd, selectedDateInd]);
  useEffect(() => {
    let parameterDetailsArr = [];
    let tempData = [...selectedTestParameters];

    for (let po of tempData) {
      if (po.dateChecked === true) {
        let parameterDetailsObj = {
          investigationDate: po.investigationDate,
          parameters: [],
        };

        for (let pc of po.testParameters) {
          if (pc.parameterChecked === true) {
            let parameterObj = {
              parameterName: pc.parameterName,
              reportValues: pc.finalResult,
              normalRange: pc.normalRange,
            };

            parameterDetailsObj.parameters.push(parameterObj);
          }
        }

        parameterDetailsArr.push(parameterDetailsObj);
      }
    }
  }, [selectedParameterInd, selectedDateInd]);
  const handleInputChange = () => {};

  const [scrollPosition, setScrollPosition] = useState(0);

  const onScrollOnto = (e) => {
    const { scrollTop } = e.target;
    setScrollPosition(scrollTop);

    // Synchronize scrolling for other elements
    const elementsToScroll = document.querySelectorAll(".sync-scroll");
    elementsToScroll.forEach((element) => {
      if (element !== e.target) {
        element.scrollTop = scrollTop;
      }
    });
  };
  // || patientInfo?.patientId
  // || patientInfo?.visitId,

  console.log("patientInfoPathlogy", patientInfo);

  const getParameterTrendData = (parameter) => {
    // showSpinner(true);
    setCurrentParameterTrendData(parameter);
    setOpenTrendModal(true);
    // getParameterTrend(
    //   patientInfo?.patientVisitId || patientInfo?.visitId,
    //   parameter?.parameterId,
    //   selectedPathTest?.testId
    // )
    //   .then((response) => {
    //     const filteredData = response.data.result?.filter(
    //       (item) => !/[a-zA-Z]/.test(item.reportvalue)
    //     );
    //     console.log("filteredData321", filteredData);

    //     setParameterTrendData([...filteredData]);
    //     let arr = [];
    //     filteredData.forEach((item) => {
    //       let obj = {
    //         ...item,
    //         formattedVisitDate: new Date(item.visitdate).toLocaleDateString(),
    //       };
    //       if (Number.isInteger(parseInt(item.reportvalue))) {
    //         arr.push(obj);
    //       }
    //     });
    //     console.log("arr", arr);
    //     setGraphData([...arr]);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };

  console.log("patientInfo", patientInfo);

  return (
    <>
      <Modal open={openInvestigationModal}>
        <Box sx={ModalStyle} className="w-[95%] h-[95%] overflow-auto">
          <div className="flex justify-between">
            <div className="font-semibold text-lg">Investigations</div>
            {/* <CheckBoxField
              control={control}
              name="isDischargeSumary"
              label="Discharge Summary"
            /> */}
            <button
              onClick={() => {
                setOpenInvestigationModal(false);
                setSelectedPathTest(null);
                setSelectedPathTestIndex(null);
                setValues(0);
                setReportPdf("");
                setSelectedRadioReportIndex(null);
                setSelectedRadioTestIndex(null);
              }}
            >
              <CloseModalIcon />
            </button>
          </div>
          <div className="py-1">
            <hr className="border-t-[1px] border-[#E3E3E5]" />
          </div>
          <div className="grid grid-cols-3 lg:grid-cols-2 xl:grid-cols-5 px-2 py-1 border bg-[#F7F9FB] rounded-md text-sm my-2">
            <div className="flex items-center space-x-2 col-span-2 lg:col-span-1 xl:col-span-2">
              <span className="font-semibold w-24">Patient Name</span>
              <span>:</span>
              <span className="text-customBlue font-bold text-base">
                {patientInfo?.["Patient Name"] || patientInfo?.patientName}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="font-semibold w-14 xl:w-8">UHID </span>
              <span className="text-gray-500">
                :&nbsp;{patientInfo?.UHID || patientInfo?.uhid}
              </span>
            </div>
            <div className="flex items-center space-x-2 col-span-2 lg:col-span-1">
              <span className="font-semibold w-24 xl:w-8">Age </span>
              <span className="text-gray-500">
                :&nbsp;{patientInfo?.Age || patientInfo?.age}{" "}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="font-semibold w-14 xl:w-13">Gender </span>
              <span className="text-gray-500">
                :&nbsp;{patientInfo?.Gender || patientInfo?.gender}
              </span>
            </div>
          </div>
          <div>
            <Box>
              {/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  className="text-customBlue bg-gray-100"
                  value={values}
                  onChange={handleChange}
                  textColor="none"
                  aria-label="basic tabs example"
                  sx={{
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#0B83A5",
                    },
                  }}
                >
                  <Tab label="Pathology" {...a11yProps(0)} />
                  <Tab label="Radiology" {...a11yProps(1)} />
                </Tabs>
              </Box> */}
              {LIMSType === "Pathology" && (
                <CustomTabPanel value={values} index={0}>
                  <div className="grid grid-cols-7 gap-x-2">
                    <div className="col-span-2 border border-b-gray-100 rounded-xl p-2 h-full space-y-2 bg-[#FFFCFA]">
                      <div className="text-customBlue font-semibold">
                        Investigation
                      </div>
                      <div className="py-0.5">
                        <hr className="border-t-[1px] border-black" />
                      </div>
                      <div>
                        <SearchDropdown
                          control={control}
                          name="investigation"
                          placeholder="Investigation"
                          searchIcon={true}
                        />
                      </div>
                      <div>
                        {pathHistoryData?.map((val, index) => (
                          <div
                            className={`${
                              selectedPathTestIndex === index
                                ? "bg-[#FFC44B]"
                                : ""
                            } p-2 rounded-md cursor-pointer text-sm w-full flex space-x-2 items-center`}
                            onClick={() => {
                              setSelectedPathTestIndex(index);
                              setSelectedPathTest(val);
                              getParametersList(val?.testId);
                              setReportPdf("");
                              setIsReport(false);
                              setSelectedPathReportIndex(null);
                            }}
                          >
                            {getDischargeSummary === true && (
                              <fieldset className="-my-2">
                                <CheckBoxField
                                  control={control}
                                  name={`testCheck${index}`}
                                />
                              </fieldset>
                            )}
                            {val?.testName}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-span-5">
                      {templateOrParameter === "parameter" && (
                        <div className="grid grid-cols-5 space-x-2">
                          <div className="col-span-2 border border-b-gray-100 rounded-xl">
                            <div className="bg-customBlue text-white rounded-t-xl flex justify-center items-center h-10 text-sm font-semibold sticky top-0">
                              {selectedPathTest?.testName}
                            </div>
                            <div
                              className="overflow-y-scroll max-h-96 scrollbar-none sync-scroll"
                              onScroll={onScrollOnto}
                            >
                              <div>
                                {selectedTestParameters[0]?.testParameters?.map(
                                  (p, pIndex) => (
                                    <div className="flex items-center px-2 h-10 bg-[#F1FFF1] border-b-[0.5px] border-[#E3E3E3]">
                                      {getDischargeSummary === true && (
                                        <fieldset className="-my-2">
                                          <CheckBoxField
                                            control={control}
                                            name={`parameterCheck${pIndex}`}
                                          />
                                        </fieldset>
                                      )}
                                      <div className="flex justify-between w-full">
                                        <div className="text-sm px-2">
                                          {p?.parameterName}
                                        </div>
                                        <button
                                          type="button"
                                          onClick={() => {
                                            getParameterTrendData(p);
                                          }}
                                        >
                                          <TrendChartIcon />
                                        </button>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="overflow-x-auto col-span-3 h-full">
                            <div className="flex space-x-2 w-full">
                              {selectedTestParameters?.map((pv, pvIndex) => {
                                return (
                                  <div
                                    className={` ${
                                      pvIndex % 2 === 1 ? "bg-[#EAF6FF]" : ""
                                    } border border-b-gray-100 rounded-xl h-full`}
                                  >
                                    <div className="flex space-x-2 justify-center items-center w-52 sticky top-0">
                                      <div className="flex justify-center items-center h-10 text-sm font-semibold">
                                        {pv.investigationDate}
                                      </div>
                                      <fieldset className="">
                                        {getDischargeSummary === true && (
                                          <CheckBoxField
                                            control={control}
                                            name={`dateCheck${pvIndex}`}
                                          />
                                        )}
                                      </fieldset>
                                    </div>
                                    <div className="px-2">
                                      <hr className="border-t-[1px] border-black" />
                                    </div>
                                    <div
                                      className="overflow-y-scroll max-h-96 scrollbar-none sync-scroll"
                                      onScroll={onScrollOnto}
                                    >
                                      <div>
                                        {pv.testParameters?.map((v, vIndex) => (
                                          <div
                                            className={`border-b-[0.5px] border-[#E3E3E3] h-10 flex items-center`}
                                          >
                                            <div
                                              className={`${
                                                v.isValid === false
                                                  ? "bg-[#FECCCC]"
                                                  : ""
                                              } rounded-md mx-2 px-4 w-max`}
                                            >
                                              {v.finalResult}
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      )}
                      {templateOrParameter === "template" && (
                        <div className="grid grid-cols-5 gap-x-2 h-full">
                          <div className="space-y-2">
                            {selectedTestParameters?.map((template, pIndex) => {
                              return (
                                <div
                                  onClick={() => {
                                    setSelectedPathReportIndex(pIndex);
                                    setIsReport(false);
                                    setReportPdf("");
                                    handlePrintReport(
                                      template.testTemplates.patientVisitId,
                                      template.orderId,
                                      template.testTemplates.investigationId,
                                      "pathology"
                                    );
                                  }}
                                  className={`${
                                    selectedPathReportIndex === pIndex
                                      ? "bg-customBlue text-white"
                                      : ""
                                  } flex justify-center items-center border border-customBlue text-customBlue rounded-lg p-2 cursor-pointer`}
                                >
                                  <div>{template.investigationDate}</div>
                                </div>
                              );
                            })}
                          </div>
                          <div className="col-span-4 h-full border border-b-gray-100 rounded-xl p-2">
                            {isReport === true ? (
                              <>
                                {reportPdf !== "" ? (
                                  <>
                                    {/* <embed
                              src={reportPdf}
                              frameBorder="0"
                              width="100%"
                              height="100%"
                            /> */}
                                    <iframe
                                      // key={index} // Add a unique key for each embed element
                                      width="100%"
                                      height="700"
                                      src={`${fileURL}#toolbar=0&navpanes=0&scrollbar=0`}
                                      target="_blank"
                                    />
                                  </>
                                ) : (
                                  <div className="h-full w-full flex items-center justify-center">
                                    <p className="font-semibold">
                                      Report is Not Available
                                    </p>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="h-full w-full flex items-center justify-center">
                                <p className="font-semibold">
                                  Document Preview
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </CustomTabPanel>
              )}
              {LIMSType === "Radiology" && (
                <CustomTabPanel
                  value={values}
                  index={LIMSType === "Radiology" ? 0 : 1}
                >
                  <div className="grid grid-cols-5 gap-x-2 min-h-[400px] max-h-full">
                    <div className="border border-b-gray-100 rounded-xl p-2 min-h-96 max-h-full space-y-2 bg-[#FFFCFA]">
                      <div className="text-customBlue font-semibold">
                        Investigation
                      </div>
                      <div className="py-0.5">
                        <hr className="border-t-[1px] border-black" />
                      </div>
                      <div>
                        <SearchDropdown
                          control={control}
                          name="investigation"
                          placeholder="Investigation"
                          searchIcon={true}
                        />
                      </div>
                      <div>
                        {radioHistoryData?.map((val, index) => (
                          <div
                            className={`${
                              selectedRadioTestIndex === index
                                ? "bg-[#FFC44B]"
                                : ""
                            } p-2 rounded-md cursor-pointer text-sm w-full flex space-x-2 items-center`}
                            onClick={() => {
                              setSelectedRadioTestIndex(index);
                              setSelectedRadioTest(val);
                              setReportPdf("");
                              setIsReport(false);
                              getRadiologytemplates(val?.testId);
                              setSelectedRadioReportIndex(null);
                            }}
                          >
                            {getDischargeSummary === true && (
                              <fieldset className="-my-2">
                                <CheckBoxField
                                  control={control}
                                  name={`testCheck${index}`}
                                />
                              </fieldset>
                            )}
                            {val?.testName}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="h-full space-y-2">
                      {selectedTestTemplates?.map((r, rIndex) => (
                        <div
                          onClick={() => {
                            setSelectedRadioReportIndex(rIndex);
                            setIsReport(false);
                            setReportPdf("");
                            handlePrintReport(
                              r.testTemplates.patientVisitId,
                              r.orderId,
                              r.testTemplates.investigationId,
                              "radiology"
                            );
                          }}
                          className={`${
                            selectedRadioReportIndex === rIndex
                              ? "bg-customBlue text-white"
                              : ""
                          } flex justify-center items-center border border-customBlue text-customBlue rounded-lg p-2 cursor-pointer`}
                        >
                          <div>{r.investigationDate}</div>
                        </div>
                      ))}
                    </div>
                    <div className="col-span-3 h-full border border-b-gray-100 rounded-xl p-2">
                      {isReport === true ? (
                        <>
                          {reportPdf !== "" ? (
                            <>
                              {/* <embed
                              src={reportPdf}
                              frameBorder="0"
                              width="100%"
                              height="100%"
                            /> */}
                              <iframe
                                // key={index} // Add a unique key for each embed element
                                width="100%"
                                height="700"
                                src={`${fileURL}#toolbar=0&navpanes=0&scrollbar=0`}
                                target="_blank"
                              />
                            </>
                          ) : (
                            <div className="h-full w-full flex items-center justify-center">
                              <p className="font-semibold">
                                Report is Not Available
                              </p>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="h-full w-full flex items-center justify-center">
                          <p className="font-semibold">Document Preview</p>
                        </div>
                      )}
                    </div>
                  </div>
                </CustomTabPanel>
              )}
            </Box>
          </div>
        </Box>
      </Modal>
      <ViewTrendModal
        openTrendModal={openTrendModal}
        setOpenTrendModal={setOpenTrendModal}
        parameterTrendData={parameterTrendData}
        graphData={graphData}
        currentParameterTrendData={currentParameterTrendData}
        // selectedObjTest={selectedObjTest}
        patientDetails={patientInfo}
      />
    </>
  );
}

